import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On every route change (pathname update), reset the window scroll
 * position to the top. Renders nothing.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
